var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFallbackSilk(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.13 30.674H9.87l.13.826L7 33 1 21l1.989-10.826 6.737-3V5h7.486v2.174l6.788 3L26 21l-6 12-3-1.5.13-.826zM8 25l-1-8-1 4 2 4zm11.425-.062L20 17l1 4-1.575 3.938z",
    fill: "silver"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36 12.923C36 15.642 33.761 16 31 16s-5-.358-5-3.077S28.239 8 31 8s5 2.204 5 4.923z",
    fill: "silver"
  })));
}
SvgFallbackSilk.displayName = 'FallbackSilk';
export default SvgFallbackSilk;